var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoToQuotaPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2578 12.7344V3.73438H11.2578C9.28 3.73437 7.34661 4.32086 5.70211 5.41968C4.05762 6.51849 2.7759 8.08028 2.01902 9.90754C1.26215 11.7348 1.06411 13.7455 1.44996 15.6853C1.83582 17.6251 2.78822 19.4069 4.18675 20.8054C5.58527 22.204 7.3671 23.1564 9.30691 23.5422C11.2467 23.9281 13.2574 23.73 15.0847 22.9732C16.9119 22.2163 18.4737 20.9346 19.5725 19.2901C20.6713 17.6456 21.2578 15.7122 21.2578 13.7344V12.7344H12.2578Z",
    fill: "#264C86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2578 10.7344V1.73438C16.6448 1.73438 18.9339 2.68259 20.6218 4.37041C22.3096 6.05824 23.2578 8.34743 23.2578 10.7344H14.2578Z",
    fill: "#264C86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToQuotaPage);
export default __webpack_public_path__ + "static/media/GoToQuotaPage.68e3b67c8d78be0dc6416340d9ef091e.svg";
export { ForwardRef as ReactComponent };